(() => {
  const config = document.getElementById('ccr-home-reviews-loader');
  if (!config) return;
  let started = false;
  let observer;
  const load = () => {
    if (started || document.getElementById('grc-widgets')) return;
    started = true;
    if (observer) observer.disconnect();
    const script = document.createElement('script');
    script.id = 'grc-widgets';
    script.src = 'https://widgets.guaranteed-reviews.com/static/widgets.min.js';
    script.async = true;
    script.dataset.publicKey = config.dataset.publicKey;
    script.dataset.lang = config.dataset.lang;
    script.addEventListener('load', () => {
      if (document.readyState === 'complete' && typeof window.loadGRCWidgets === 'function') {
        window.loadGRCWidgets();
      }
    }, { once: true });
    document.head.appendChild(script);
  };
  const observe = () => {
    if (started) return;
    const targets = document.querySelectorAll('.grc-category-stars, .grc-site-iframe, .grc-site-rating, .grc-product-summary, .grc-product-reviews, .grc-global-trustlink');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) load();
    }, { rootMargin: '100px 0px' });
    targets.forEach(target => observer.observe(target));
  };
  observe();
  document.addEventListener('shopify:section:load', observe);
})();
